import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Global API Configuration Service
 * 
 * This service provides a centralized location for API base URL configuration.
 * To change the API base URL for all services, update the BASE_URL property below.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  /** Base URL for all API endpoints from Angular build environment. */
  public readonly BASE_URL = environment.apiBaseUrl;

  /**
   * Get the full URL for an endpoint
   * @param endpoint API endpoint (without leading slash)
   * @returns Full URL string
   */
  getUrl(endpoint: string): string {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${this.BASE_URL}/${cleanEndpoint}`;
  }

  /**
   * Get the base URL
   * @returns Base URL string
   */
  getBaseUrl(): string {
    return this.BASE_URL;
  }
}
